import logo from './../img/logo.svg'
import { useState, useRef, useEffect } from 'react';
import Config from '../Config';
import { Messages } from './Messages';
import ComboBox from '../helpers/ComboBox';
import { InputText } from '../helpers/InputText';
import { ClientSaldo } from './ClientSaldo';
import { ClientExpertBox } from './ClientExpertBox';


 
export function ClientChatTemp(props)
{     
    const [email, setEmail] = useState({
        email: props.userData.email,
        email_status: 'invalid',
      });

    const [experts, setExperts] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [expertData,setExpertData] = useState(null);
    const [komunikat,setKomunikat] = useState('');  

    var tmpData = email;
    
    const getUser = () => {
        
        
        if(email.email_status=='invalid')
        {
            setKomunikat(<span className='msg_error'>Wprowadzono błędny adres email</span>);

            return <div></div>;

        }
        else
        {
            setKomunikat(<div className='loader'></div>);
        }

        let sendData = ({
            email:email.email,
        })

        fetch(Config.url+'/rest_public,verifyByEmail',{
            method:'POST',
            body: JSON.stringify(sendData), 
            mode:'cors',
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': ''
            }
        })
        .then(res => res.json() )
        .then(res => {
            
            setKomunikat();   

                if(res.status=='ok')
                {   
                    

                    if(props.userData.client!='' && props.userData.client!=res.client )
                    {
                        props.setUser(
                            'USER',
                            '',
                            '',
                            '',
                            0,
                            email.email,
                            props.userData.expertId,
                            res.client,
                            '',
                            ''
                        );

                        return <div></div>;
                    }
                    else
                    {
                        props.setUser(
                            'USER',
                            props.userData.apiKey,
                            props.userData.chat_id,
                            props.userData.crypt,
                            props.userData.saldo,
                            email.email,
                            props.userData.expertId,
                            res.client,
                            props.userData.orderId,
                            props.userData.stawka_klient
                        );

                        return <div></div>;
                    }
                    
                     
                   
                   
                }
            

        })
        .catch(err => {
            console.log("Err " + err);
        });
    }  

    const getExpertData = (epxertId) => {
        
        

        //if(props.userData.expertId==0) return;

        let sendData = ({
            expertId:epxertId,
            client:props.userData.client            
        })

        fetch(Config.url+'/rest_public,getExpertData',{
            method:'POST',
            body: JSON.stringify(sendData), 
            mode:'cors',
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.apiKey
            }
        })
        .then(res => res.json() )
        .then(res => {
            
           

            if(res.status=='ok')
            {   
                setExpertData(res);

                props.setUser(
                    props.userData.userType,
                    props.userData.apiKey,
                    props.userData.chat_id,
                    props.userData.crypt,
                    props.userData.saldo,
                    props.userData.email,
                    epxertId,
                    props.userData.client,
                    props.userData.orderId,
                    res.data.t2_stawka_klient
                ); 

                
    
                
            }
            

        })
        .catch(err => {
            console.log("Err " + err);
        });

        return false;
    }
    
    const getExperts = () => {
        
        fetch(Config.url+'/rest_public,epxertArrayChat',{
            method:'POST',
            body: JSON.stringify([]), 
            mode:'cors',
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.userData.apiKey
            }
        })
        .then(res => res.json() )
        .then(res => {
        
            if(res.status=='ok')
            {   
                setExperts(res.data);
            }

        })
        .catch(err => {
            console.log("Err " + err);
        });
    }

    if(experts.length==0 || experts==undefined)
    {
        getExperts();
    
        return (
            <div>
                ...
            </div>
        )
    }
        
    if(expertData===null && props.userData.expertId>0)
    {
        getExpertData(props.userData.expertId);
        
        return (
            <div>
                ...
            </div>
        )
    }        

    const selectExpert= (value) =>{

        var expertId = value.value;

        getExpertData(expertId);

        return <div></div>
    }
    



    const changeValueListner = (name,value,status) =>{
        
        tmpData[name] = value;
        tmpData[name+"_status"] = status; 

        setEmail(  JSON.parse(JSON.stringify(tmpData)) );    
        
        /*
        if(status=='valid')
        {
            props.setEmail(value);

            return <div></div>
        }
        */
    }
    
    


    return (
        <div>
            <div class="mw-forms__header">
                <h1>Chat</h1> 
            </div>
            <div id="chat_form">
                
                <div class="mw-card " id="zamowione_rozmowy">
                    <div class="mw-card__content">
                     
                        <div class="mw-forms__field">
                            <div class="mw-forms__field">
                                <label class="mw-forms__label" >Wybierz doradcę</label>
                                <ComboBox name='expertId' array={experts} css='mw-forms__input' selected={props.userData.expertId} selectValue={selectExpert} />
                            </div>   
                        </div>
                        
                        <div class="mw-forms__field mw-forms__two_col">
                            <div class="mw-forms__field">
                                <label class="mw-forms__label" >Adres email</label>
                                <InputText type='email' required='true' placeholder="Uzupełnij adres e-mail" name='email' className='mw-forms__input w75' changeValue={changeValueListner} value={email.email}/>
                                
                            </div>
                            <div class="mw-forms__field">
                                <label class="mw-forms__label" ><br></br></label>
                                <span className='w25 mw-button mw-button--lg' onClick={getUser}>Wyślij</span>
                            </div>
                               
                        </div>

                        
                        
            
                        <div class="mw-forms__field">

                            {komunikat} 

                            <ClientSaldo userData={props.userData} setUser={props.setUser} setClient={props.setClient}  />
                            <ClientExpertBox  userData={props.userData} setUser={props.setUser} expertData={expertData} />
                        </div>
                    </div>
                </div>
            </div>
       
        </div>
    )
   
}
